// ++ 1. mouse move only recently
// ++3. reset all with a click
// ++4. save image on click-press
// ++4. orbitcontrols around, hide floor
// ++5. optimize model - geometry + texture compress size
// ++6. ALL TO DRACO!! for load size
// 2. pick number on load
//create nice loader!!

import * as THREE from "three";
import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from 'three-mesh-bvh';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js';
import {mergeBufferGeometries}  from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { ShadowMapViewer } from 'three/examples/jsm/utils/ShadowMapViewer.js';
const SHADOW_MAP_WIDTH = 2048, SHADOW_MAP_HEIGHT = 1024;
// console.log(mergeBufferGeometries)
import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertex.glsl";
import GUI from 'lil-gui'; 
import gsap from "gsap";
const createInputEvents = require('simple-input-events');

THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;


import raycast from '../models/tank.gltf'
import tank from '../models/tank-v1.glb'
import diff from '../map.png'
// import sunflower from '../models/sunf.glb'
import sunflower from '../models/test-v2.glb'
// import sunflower from '../models/bb.glb'
import sunflower1 from '../models/b-v1.glb'


let CURVY = Math.random()>0.5

export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer({
      preserveDrawingBuffer: true
    });
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5))
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0x000000, 1); 
    this.renderer.physicallyCorrectLights = true;
    this.renderer.shadowMap.enabled = true;
    this.moseMoved = false;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.event = createInputEvents(this.renderer.domElement);
    this.framesSinceMouseMoved = 0;
    this.raycaster = new THREE.Raycaster();
    this.raycaster.firstHitOnly = true;
    this.pointer = new THREE.Vector2();
    this.currentViewMode = 1;

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      70,
      window.innerWidth / window.innerHeight,
      0.01,
      100
    );

    this.count = 4500;
    this.ages = new Float32Array( this.count );
    this.scales = new Float32Array( this.count );
    this.growthspeed = new Float32Array( this.count );
    this.dummy = new THREE.Object3D();
    this.positions = []

    this._position = new THREE.Vector3();
    this._normal = new THREE.Vector3();
    this._tempnormal = new THREE.Vector3();
    this._scale = new THREE.Vector3();
    this.currentPoint = new THREE.Vector3(100,100,100)

    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );

    this.loader = new GLTFLoader();
    this.dracoloader = new DRACOLoader();
    this.dracoloader.setDecoderPath(''); // use a full url path
    this.loader.setDRACOLoader(this.dracoloader);
    // this.camera.position.set(8, 3, 0);
    // x: -0.46697568399756584, y: 1.8457882367646887, z: 3.729067074755239
    this.camera.position.set(-0.5, 2, 5.1);
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.target = new THREE.Vector3(0,0,-5)
    this.controls.update()
    this.controls.maxPolarAngle = Math.PI/2; 
    this.controls.minDistance = 1;
    this.controls.maxDistance = 15;
    this.time = 0;

    this.isPlaying = true;

    this.loader.load(CURVY?sunflower1:sunflower,(glb)=>{
      // console.log(glb.scene)
      // this.sunflower = glb.scene.getObjectByName('Sunflower_Sunflower1_0');
      // this.sunflower = glb.scene.getObjectByName('extrudedSurface2_sunflowe_0');
      // this.sunflower = glb.scene.getObjectByName('margarita_flower');
      // this.sunflower = glb.scene.getObjectByName('Object_2');
      this.sunflower = glb.scene.getObjectByName(CURVY?'Default':'Object_2');
      // this.sunflower = glb.scene.getObjectByName('Subdivision_Surface');
      // this.sunflower.geometry.center()
      // this.sunflower.material = new THREE.MeshBasicMaterial({color: 0xff0000})
      // this.scene.add(glb.scene)
      // console.log(this.sunflower)


      this.loader.load(tank,(gltf)=>{
        this.tank = gltf.scene.children[0]
        this.scene.add(this.tank);
        this.tank.traverse(m=>{
          if(m.isMesh){
            // console.log(m)
            m.userData.originalMaterial = m.material;
            m.userData.wireframeMaterial = new THREE.MeshStandardMaterial({color: 0x00ffff,wireframe: true});
            // m.material = 
            m.castShadow = true;
            m.receiveShadow = true;
            // m.geometry.computeFaceNormals();
            m.geometry.computeVertexNormals();
          }
        })

        let gs = []
        this.tank.children.forEach(m=>{
          gs.push(m.geometry);
        })
        // console.log(gs)
        this.finalGeometry = mergeBufferGeometries(gs);
        // console.log(this.finalGeometry )
        this.finalMesh = new THREE.Mesh(this.finalGeometry,new THREE.MeshNormalMaterial());
        this.finalMesh.castShadow = true;
        this.finalMesh.receiveShadow = true;
        // this.scene.add(this.finalMesh);

        this.addObjects();
        this.resize();
        this.render();
        this.setupResize();
        this.addLights()
        // this.createHUD()
        // this.testShadows()
        this.raycasterEvent()
        this.keyEvents()
        document.body.classList.add('is-loaded')
      })

    })
    
    
    
    // this.settings();
  }

  keyEvents(){
    document.addEventListener('keypress', (e)=>{
      if(e.code=='KeyR'){
        this.resetFlowers()
      }
      if(e.code=='KeyS'){
        this.saveScreenShot()
      }

      if(e.code=='KeyW'){
        this.swapMaterials()
      }
    });
  }

  swapMaterials(){
    this.tank.traverse(m=>{
    if(m.isMesh){
      if(this.currentViewMode==1){
        m.material = m.userData.wireframeMaterial ;
      } else{
        m.material = m.userData.originalMaterial ;
      }
    }
  })
    this.currentViewMode = (this.currentViewMode + 1)%2
  }

  saveScreenShot(){
    let strMime = "image/jpeg";
    let imgData = this.renderer.domElement.toDataURL(strMime);
    this.saveFile(imgData.replace(strMime, 'image/octet-stream'), 'snapshot.jpg');
  }

  saveFile(strData, filename) {
      var link = document.createElement('a');
      if (typeof link.download === 'string') {
          document.body.appendChild(link); //Firefox requires the link to be in the body
          link.download = filename;
          link.href = strData;
          link.click();
          document.body.removeChild(link); //remove the link when done
      } else {
          location.replace(uri);
      }
  }

  testShadows(){

    let ground = new THREE.Mesh(
      new THREE.CircleBufferGeometry(3,10),
      new THREE.MeshStandardMaterial({color: 0xff0000})
    )
    ground.receiveShadow=ground.castShadow = true;
    ground.rotation.x = -Math.PI/2
    this.scene.add(ground)
    ground.position.y = -2;

    let box = new THREE.Mesh(
      new THREE.SphereBufferGeometry(0.5,25,25),
      new THREE.MeshStandardMaterial({color: 0xffffff})
    )
    box.receiveShadow=box.castShadow = true;
    this.scene.add(box)
    box.position.y = 1;


  }

  raycasterEvent() {

    this.loader.load(raycast,(gltf)=>{
      // console.log(gltf.scene.children[0].children,'raycast')
      // this.scene.add(gltf.scene);

    
    this.ball = new THREE.Mesh(
      new THREE.SphereBufferGeometry(0.03, 32, 32),
      new THREE.MeshBasicMaterial({
        color: 0xffffff
      })
    );
    this.scene.add(this.ball);
    // this.ball.visible = false;

    let testmesh = new THREE.Mesh(
      this.finalGeometry,
      new THREE.MeshBasicMaterial({
        transparent: true,
        color: 0xff0000
      })
    )
    // testmesh.rotation.x = -Math.PI/2
    testmesh.visible = false;
    // this.scene.add(testmesh)

    this.event.on('move', ({
      position,
      event,
      inside,
      dragging
    }) => {
      this.moseMoved = true;
      this.pointer.x = (position[0] / window.innerWidth) * 2 - 1;
      this.pointer.y = -(position[1] / window.innerHeight) * 2 + 1;

      this.raycaster.setFromCamera(this.pointer, this.camera);

      const intersects = this.raycaster.intersectObjects(gltf.scene.children[0].children);


      if (intersects[0]) {
        let p = intersects[0].point;
        this.currentPoint.copy(p);
        this.ball.position.copy(p);

      }


    });



  })

  }

  

  settings() {
    let that = this;
    this.settings = {
      progress: 0,
    };
    this.gui = new GUI();
    this.gui.add(this.settings, "progress", 0, 1, 0.01);
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    this.camera.updateProjectionMatrix();
  }

  addObjects() {
    let that = this;
    let groundPlane = new THREE.Mesh(
      new THREE.CircleBufferGeometry(30,30),
      new THREE.MeshStandardMaterial({color: 0x000000})
    );
    groundPlane.receiveShadow = true;
    groundPlane.rotation.x = -Math.PI/2
    groundPlane.position.y = -1.66;
    this.scene.add(groundPlane);
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable"
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },
        resolution: { value: new THREE.Vector4() },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment
    });

    this.material = new THREE.MeshBasicMaterial({color: 0xff0000})

    this.geometry = new THREE.PlaneGeometry(0.1,0.1);
    this.geometry  = this.sunflower.geometry;
    let s = 0.004;
    s *= 0.5;
    const defaultTransform = new THREE.Matrix4()
      .makeRotationX( CURVY?Math.PI/2:0 )
      // .makeRotationY( -Math.PI/2 )
      .multiply( new THREE.Matrix4().makeScale(s,s,s) )
    const defaultTransform1 = new THREE.Matrix4().makeTranslation(0,0,0)

    this.geometry.applyMatrix4( defaultTransform );
    this.geometry.applyMatrix4( defaultTransform1 );

    // this.sunflower.material  = new THREE.MeshStandardMaterial({color: 0xcffff00})
    // console.log(this.sunflower.material,new THREE.MeshStandardMaterial({color: 0x00ff00}))
    let m = new THREE.MeshStandardMaterial({color: 0xffffff,side:THREE.DoubleSide});
    m.map = this.sunflower.material.map;
    let t = new THREE.TextureLoader().load(diff)
    // if(!CURVY) 
    t.encoding = THREE.sRGBEncoding;
    t.flipY = false;
    if(!CURVY) m.map = t;
    // m.aoMap = this.sunflower.material.aoMap;
    m.emissiveMap = this.sunflower.material.map;
    m.emissiveIntensity = 1;
    // alert(this.sunflower.material.emissiveIntensity)
    m.emissive = new THREE.Color('#888');
    m.side = THREE.DoubleSide;
    m.transparent = true;
    this.geometry.computeVertexNormals()
    // m = new THREE.MeshBasicMaterial({color: 0xff0000,side:THREE.DoubleSide})
    // this.plane = new THREE.InstancedMesh(this.geometry, this.sunflower.material,this.count);
    this.plane = new THREE.InstancedMesh(this.geometry, m,this.count);
    this.plane.castShadow = true;
    this.plane.receiveShadow = true;
    this.scene.add(this.plane);
    // console.log(this.tank.children[0])
    this.sampler = new MeshSurfaceSampler( this.finalMesh )
    // .setWeightAttribute( api.distribution === 'weighted' ? 'uv' : null )
    .setWeightAttribute('uv' )
    .build();
    

    for ( let i = 0; i < this.count; i ++ ) {

      this.ages[ i ] = 0;
      this.growthspeed[ i ] = 0;
      this.scales[ i ] = 1

      this.resampleParticle( i );

    }



    this.plane.instanceMatrix.needsUpdate = true;
    // console.log(this.plane.instanceMatrix)
    // blossomMesh.instanceMatrix.needsUpdate = true;
  }


  resampleParticle( i ) {

    

    this.sampler.sample( this._position, this._normal );
    this._tempnormal.copy(this._normal)
    this._normal.add( this._position );
    // console.log(this._position)

    // rise it up
    // this._position.add( this._tempnormal.clone().multiplyScalar(0.05) );
    this.positions[i] = [this._position.clone(),this._normal.clone()];
    this.dummy.position.copy( this._position );
    this.dummy.scale.set( this.scales[ i ], this.scales[ i ], this.scales[ i ] );
    this.dummy.lookAt( this._normal );
    this.dummy.updateMatrix();

    this.plane.setMatrixAt( i, this.dummy.matrix );

  }

  // func to set scale

  // raycaster to get current 3d point

  // loop thru all, get distance - set scale and set relax

  setScale(i,forcescale){
    this.dummy.position.copy( this.positions[i][0] );
    
    let s = Math.min(2, this.ages[ i ] + this.time*0);
    let d = this.currentPoint.distanceTo(this.positions[i][0]);
    
    if(d<1){
      this.growthspeed[i] +=0.01;
    } else{
      this.growthspeed[i] *=0.9;
    }

    this.growthspeed[i] = Math.min(this.growthspeed[i],0.1);

    this.ages[i] +=this.growthspeed[i];
    this.ages[i] = Math.min(this.ages[i],2)

    if(!(forcescale=== undefined)) {
      this.ages[i] = 0;this.growthspeed[i] = 0;
    }


    // this.dummy.scale.set( this.scales[ i ], this.scales[ i ], this.scales[ i ] );
    this.dummy.scale.set( this.ages[ i ],this.ages[ i ],this.ages[ i ] );
    this.dummy.lookAt( this.positions[i][1] );
    this.dummy.updateMatrix();
    this.plane.setMatrixAt( i, this.dummy.matrix );

    // console.log(this.positions[i][0])
  }

  resetFlowers(){
    for (let i = 0; i < this.count; i++) {
      this.dummy.position.copy( this.positions[i][0] );
      this.ages[i] = 0;
      this.dummy.scale.set( this.ages[ i ],this.ages[ i ],this.ages[ i ] );
      this.dummy.updateMatrix();
      this.plane.setMatrixAt( i, this.dummy.matrix );
    }
    this.plane.instanceMatrix.needsUpdate = true;
  }


  addLights(){
    const light1  = new THREE.AmbientLight(0xffffff, 0.3);
    this.scene.add( light1 );

    this.light2  = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
    this.light2.castShadow = true;
    this.light2.shadow.camera.near = 0.1;
    this.light2.shadow.camera.far = 20;
    // this.light2.shadow.bias = 0.0000000001;
    this.light2.shadow.bias = -0.01;
    this.light2.shadow.camera.right = 10;
    this.light2.shadow.camera.left = - 10;
    this.light2.shadow.camera.top	= 10;
    this.light2.shadow.camera.bottom = - 10;

    this.light2.shadow.mapSize.width = SHADOW_MAP_WIDTH;
    this.light2.shadow.mapSize.height = SHADOW_MAP_HEIGHT;
    // light2.position.set(0.5, 0, 0.866); // ~60º
    this.light2.position.set(2.7, 3, 0); // ~60º
    this.scene.add( this.light2 );

    const helper = new THREE.DirectionalLightHelper( this.light2, 2 );
    // this.scene.add( helper );

    // this.scene.add( new THREE.CameraHelper( this.light2.shadow.camera ) );
  }

  createHUD() {

    this.lightShadowMapViewer = new ShadowMapViewer( this.light2 );
    this.lightShadowMapViewer.position.x = 10;
    this.lightShadowMapViewer.position.y = this.height - ( SHADOW_MAP_HEIGHT / 4 ) - 10;
    this.lightShadowMapViewer.size.width = SHADOW_MAP_WIDTH / 4;
    this.lightShadowMapViewer.size.height = SHADOW_MAP_HEIGHT / 4;
    this.lightShadowMapViewer.update();

  }

  render() {
    if (!this.isPlaying) return;
    // console.log(this.camera.position)
    this.time += 0.05;
    if(this.moseMoved) {
      this.moseMoved = false;
      this.framesSinceMouseMoved = 0;
    } else{
      this.framesSinceMouseMoved +=1;
    }

    if(this.positions.length>10 && this.framesSinceMouseMoved<150){
      for (let i = 0; i < this.count; i++) {
        this.setScale(i)
      }
      this.plane.instanceMatrix.needsUpdate = true;
    }
    

    // if(this.lightShadowMapViewer) this.lightShadowMapViewer.render( this.renderer );
    
    // this.material.uniforms.time.value = this.time;
    requestAnimationFrame(this.render.bind(this));
    this.renderer.render(this.scene, this.camera);
  }
}

new Sketch({
  dom: document.getElementById("container")
});
